module.exports = __webpack_public_path__ + "img/img1.c6da131c.png";